var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_23_1822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.84368 11.0235H3.06207C1.37361 11.0235 0 9.64991 0 7.96145V3.15228C0 1.46074 1.37361 0.0871277 3.06207 0.0871277H9.84059C11.529 0.0871277 12.9027 1.46074 12.9027 3.14919V7.95837C12.9027 9.64682 11.529 11.0204 9.84059 11.0204L9.84368 11.0235ZM3.06207 2.27564C2.58053 2.27564 2.18543 2.66766 2.18543 3.15228V7.96145C2.18543 8.44299 2.57744 8.83809 3.06207 8.83809H9.84059C10.3221 8.83809 10.7172 8.44607 10.7172 7.96145V3.15228C10.7172 2.67075 10.3252 2.27564 9.84059 2.27564H3.06207Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.9348 17.1507H17.9372C16.2487 17.1507 14.8751 15.7771 14.8751 14.0887V3.14919C14.8751 1.46074 16.2487 0.0871277 17.9372 0.0871277H24.9348C26.6233 0.0871277 27.9969 1.46074 27.9969 3.14919V14.0856C27.9969 15.774 26.6233 17.1477 24.9348 17.1477V17.1507ZM17.9372 2.27564C17.4556 2.27564 17.0605 2.66766 17.0605 3.15228V14.0887C17.0605 14.5702 17.4525 14.9653 17.9372 14.9653H24.9348C25.4164 14.9653 25.8115 14.5733 25.8115 14.0887V3.14919C25.8115 2.66766 25.4195 2.27255 24.9348 2.27255H17.9372V2.27564Z",
    fill: "var(--menu-icon-accent, #8fb4ff)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.9348 28.0871H17.9372C16.2487 28.0871 14.8751 26.7135 14.8751 25.0251V22.4013C14.8751 20.7129 16.2487 19.3392 17.9372 19.3392H24.9348C26.6233 19.3392 27.9969 20.7129 27.9969 22.4013V25.0251C27.9969 26.7135 26.6233 28.0871 24.9348 28.0871ZM17.9372 21.5247C17.4556 21.5247 17.0605 21.9167 17.0605 22.4013V25.0251C17.0605 25.5066 17.4525 25.9017 17.9372 25.9017H24.9348C25.4164 25.9017 25.8115 25.5097 25.8115 25.0251V22.4013C25.8115 21.9198 25.4195 21.5247 24.9348 21.5247H17.9372Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.84368 28.0871H3.06207C1.37361 28.0871 0 26.7135 0 25.0251V16.058C0 14.3696 1.37361 12.996 3.06207 12.996H9.84059C11.529 12.996 12.9027 14.3696 12.9027 16.058V25.0251C12.9027 26.7135 11.529 28.0871 9.84059 28.0871H9.84368ZM3.06207 15.1814C2.58053 15.1814 2.18543 15.5734 2.18543 16.058V25.0251C2.18543 25.5066 2.57744 25.9017 3.06207 25.9017H9.84059C10.3221 25.9017 10.7172 25.5097 10.7172 25.0251V16.058C10.7172 15.5765 10.3252 15.1814 9.84059 15.1814H3.06207Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.0871277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.8e79dbb4db9a5af545c0f3d3e63fbf29.svg";
export { ForwardRef as ReactComponent };